// Searches for image blocks (either CoreImage or AcfArtDirectionImage) and adds an eager loading attribute to the image block.
// Used in places where you need to eagerly load images, for eaxmple, hero blocks.

export default function eagerLoadChildImages(innerBlocks) {
	innerBlocks.map((block) => {
    Object.preventExtensions(block);
		if (block['__typename'] === 'CoreImage' || block['__typename'] === 'AcfArtDirectionImage') {
      block.attributes['imageLoading'] = 'eager';
		} else if (Array.isArray(block.innerBlocks) && block.innerBlocks.length > 0) {
			eagerLoadChildImages(block.innerBlocks);
		}
    return block
	});
  return innerBlocks
}
